export const messages = {
  noResults: 'No Messages found',
  markAsRead: 'Mark as read',
  you: 'You',
};
